import React, { useEffect, useState } from 'react';

import { MAIN_THEME } from '@styles';

import { IInformationBoxTab } from '.';

import { makeStyles } from 'tss-react/mui';

interface IInformationBoxHeaderProps {
  tab: IInformationBoxTab;
}
const useStyles = makeStyles<{ colCount: number }>()((_, { colCount }) => ({
  container: {
    display: 'block',
    width: '100%'
  },
  row: {
    padding: '12px 0',
    borderBottom: `1px solid ${MAIN_THEME.color.white92}`,
    textAlign: 'left',
    display: 'grid',
    gridTemplateColumns: `40% repeat(${colCount}, 1fr)`,
    gridGap: '5px',
    gridAutoRows: 'auto'
  },
  title: {
    color: MAIN_THEME.color.black,
    display: 'inline-block',
    textAlign: 'left',
    fontSize: MAIN_THEME.fontSize.xs,
    fontWeight: 'bold',
    height: '13px'
  },
  text: {
    color: MAIN_THEME.color.black,
    display: 'inline-block',
    textAlign: 'right',
    fontSize: MAIN_THEME.fontSize.xs,
    fontWeight: 'bold',
    lineHeight: '13px'
  }
}));

const InformationBoxHeader: React.FC<IInformationBoxHeaderProps> = ({
  tab
}) => {
  const [colCount, setColCount] = useState<number>(1);
  const classes = useStyles({ colCount }).classes;

  useEffect(() => {
    const value = Object.keys(tab.data).length;
    setColCount(value);
  }, [tab.data]);

  return (
    <>
      {colCount > 0 && tab.supportsGrouping && (
        <div className={classes.row}>
          <div className={classes.title}>{tab.groupingTitle}</div>
          {tab.headers &&
            tab.groupingValues.map((column) => (
              <div key={column} className={classes.text}>
                {column}
              </div>
            ))}
        </div>
      )}
    </>
  );
};

export default InformationBoxHeader;
